import { render, staticRenderFns } from "./CompanionCustomers.vue?vue&type=template&id=234439bf&scoped=true"
import script from "./CompanionCustomers.vue?vue&type=script&lang=js"
export * from "./CompanionCustomers.vue?vue&type=script&lang=js"
import style0 from "./CompanionCustomers.vue?vue&type=style&index=0&id=234439bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234439bf",
  null
  
)

export default component.exports